module.exports = __webpack_public_path__ + "img/resource_minus.994e60d7.svg";